import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import Spinner from "../Spinner/Spinner";

const PublicRoute = ({ children }) => {
  const isLoggedIn = useSelector((state) => state.isLoggedIn);
  const authLoading = useSelector((state) => state.authLoading);

  // wait until auth status is known
  if (authLoading) return <Spinner loadingInfo="Loading..." />;

  // if logged in, redirect to home or dashboard
  if (isLoggedIn) return <Navigate to="/" replace />;

  // else render the component
  return children;
};

export default PublicRoute;